import { render, staticRenderFns } from "./roleInvitation.vue?vue&type=template&id=00806e22&scoped=true&"
import script from "./roleInvitation.vue?vue&type=script&lang=js&"
export * from "./roleInvitation.vue?vue&type=script&lang=js&"
import style0 from "./roleInvitation.vue?vue&type=style&index=0&id=00806e22&prod&lang=less&scoped=true&"
import style1 from "./roleInvitation.vue?vue&type=style&index=1&id=00806e22&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00806e22",
  null
  
)

export default component.exports